import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var BackpanelDrawing = /** @class */ (function (_super) {
    tslib_1.__extends(BackpanelDrawing, _super);
    function BackpanelDrawing() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.containerLength = 4500;
        _this.containerHeight = 1500;
        return _this;
    }
    Object.defineProperty(BackpanelDrawing.prototype, "drawingReady", {
        get: function () {
            return this.$ui.backpanelLength > 0 && this.$ui.backpanelHeight > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackpanelDrawing.prototype, "panelStyles", {
        get: function () {
            return {
                width: (this.$ui.backpanelLength / this.containerLength * 100) + '%',
                height: (this.$ui.backpanelHeight / this.containerHeight * 100) + '%',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackpanelDrawing.prototype, "depthStyles", {
        get: function () {
            return {
                height: this.$ui.backpanelStructure.width / 1.5 + 'px',
            };
        },
        enumerable: true,
        configurable: true
    });
    BackpanelDrawing = tslib_1.__decorate([
        Component
    ], BackpanelDrawing);
    return BackpanelDrawing;
}(Vue));
export default BackpanelDrawing;
